<script setup>
import { ref, onMounted } from 'vue'

import Hero from '@/components/sections/Hero.vue'
import NotJustMask from '@/components/sections/NotJustMask.vue'
import UniqueCreations from '@/components/sections/UniqueCreations.vue'
import ViralPranks from '@/components/sections/ViralPranks.vue'
import ArtistClips from '@/components/sections/ArtistClips.vue'
import MoreLooks from '@/components/sections/MoreLooks.vue'
import HandmadeMasks from '@/components/sections/HandmadeMasks.vue'
import Reviews from '@/components/sections/Reviews.vue'
import Support from '@/components/sections/Support.vue'
import MarqueeLine from '@/components/ui/MarqueeLine.vue'

import { useRequestsStore } from '@/stores/storeRequests'

const storeRequests = useRequestsStore()

// Состояния для данных бегущих строк
const marqueeOneItems = ref([])
const marqueeTwoItems = ref([])

onMounted(async () => {
	try {
		// Асинхронная подгрузка данных для бегущих строк
		const oneData = await storeRequests.getMarqueeOne()
		const twoData = await storeRequests.getMarqueeTwo()

		marqueeOneItems.value = oneData.map((item) => item.content)
		marqueeTwoItems.value = twoData.map((item) => item.content)
	} catch (error) {
		console.error('Ошибка при загрузке бегущих строк', error)
	}
})
</script>

<template>
	<Hero />

	<!-- Первая бегущая строка -->
	<MarqueeLine
		v-if="marqueeOneItems.length"
		backgroundColor="var(--primary-color)"
		textColor="var(--black)"
		direction="left"
		:speed="1"
	>
		<li v-for="(item, index) in marqueeOneItems" :key="index">{{ item }}</li>
	</MarqueeLine>

	<NotJustMask />

	<!-- Вторая бегущая строка -->
	<MarqueeLine
		v-if="marqueeTwoItems.length"
		backgroundColor="var(--black)"
		textColor="var(--white)"
		direction="left"
		:speed="1"
	>
		<li v-for="(item, index) in marqueeTwoItems" :key="index">{{ item }}</li>
	</MarqueeLine>

	<UniqueCreations />
	<ViralPranks />

	<!-- Статические бегущие строки -->
	<MarqueeLine
		backgroundColor="var(--primary-color)"
		textColor="var(--black)"
		direction="left"
		:speed="1"
	>
		<li>Устрой карнавал прямо у себя дома!</li>
		<li>Идеально для ролевых игр и создания мем фотосессии и дискотеки!</li>
		<li>Идеально для ролевых игр и создания мем фотосессии и дискотеки!</li>
	</MarqueeLine>

	<ArtistClips /> -->

	<MarqueeLine
		backgroundColor="var(--black)"
		textColor="var(--white)"
		direction="left"
		:speed="1"
	>
		<li>Более 1.5 миллиона продаж</li>
	</MarqueeLine>

	<MoreLooks />

	<MarqueeLine
		backgroundColor="var(--black)"
		textColor="var(--white)"
		direction="left"
		:speed="1"

	>
		<li>Миллионы первоплощений</li>
	</MarqueeLine>

	<HandmadeMasks />

	<Reviews />

	<Support />

	<MarqueeLine
		backgroundColor="var(--black)"
		textColor="var(--white)"
		direction="left"
		:speed="1"
	>
		<li>Миллионы первоплощений</li>
	</MarqueeLine>
</template>
